import { GrClose } from 'react-icons/gr';

import styles from './index.module.less';

/**
 * @deprecated
 * NOTE: the `headerText` prop is misnamed; it can be any kind of HTML or React content. But owing to the wide usage of this component and its slated deprecation, we will we leave it as-is. Just be careful when updating related styles to make sure the container element is block level.
 */
const Modal = ({
    headerText,
    columnWidth = 6,
    close,
    id = 'molecules-modal',
    showClose = true,
    show = false,
    children,
    maxHeight
}) => {
    const containerStyle = show ? 'container' : 'container-hidden';
    const dimensionStyles = maxHeight
        ? { maxHeight, maxWidth: columnWidth * 90 }
        : { maxWidth: columnWidth * 90 };

    return (
        <div
            id={id}
            data-testid={`${id}_subcontainer`}
            className={styles[containerStyle]}
        >
            <div
                id={`${id}_content`}
                data-testid={`${id}_content`}
                className={styles['content']}
                style={dimensionStyles}
                data-is-open={show}
            >
                <header id={`${id}_header`} className={styles['header']}>
                    <div style={{ flex: '1 1 auto' }}>{headerText}</div>
                    {showClose && (
                        <button
                            id={`${id}_close`}
                            className={styles['close']}
                            onClick={close}
                            aria-label="Close"
                        >
                            <GrClose size="16px" />
                        </button>
                    )}
                </header>
                <section id={`${id}_body`} className={styles['body']}>
                    {children}
                </section>
            </div>
        </div>
    );
};

export default Modal;
